import { EventType } from '../types/ViewModel/EventType';
import { TankersEvent } from '../types/ViewModel/TankersEvent';
import { EventTypeGroup } from '../types/ViewModel/EventTypeGroup';
import { EventTypeInput } from '../types/ViewModel/EventTypeInput';
import EventTypeInputFactory from './EventTypeInputFactory';
import { EventTypeInputGroupFactory } from './EventTypeInputGroupFactory';
import { CaptainsDocumentFactory } from './CaptainsDocumentFactory';
import { DelayEventFactory } from './DelayEventFactory';
import { RotationTreeEnum } from '../enums/rotationTreeEnum';
import { EventTypeBM } from '../types/BusinessModel/EventTypeBM';
import { EventTypeInputDelayEventTypeMapFactory } from './EventTypeInputDelayEventTypeMapFactory';
import { EventTypeInputExcludeTimeEventTypeMapFactory } from './EventTypeInputExcludeTimeEventTypeMapFactory';

export default () => {
    const questionMark =
        '<?xml version="1.0" encoding="iso-8859-1"?><!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" 	 width="365.442px" height="365.442px" viewBox="0 0 365.442 365.442" style="enable-background:new 0 0 365.442 365.442;"	 xml:space="preserve"><g>	<g>		<path d="M212.994,274.074h-68.522c-3.042,0-5.708,1.149-7.992,3.429c-2.286,2.286-3.427,4.948-3.427,7.994v68.525			c0,3.046,1.145,5.712,3.427,7.994c2.284,2.279,4.947,3.426,7.992,3.426h68.522c3.042,0,5.715-1.144,7.99-3.426			c2.29-2.282,3.433-4.948,3.433-7.994v-68.525c0-3.046-1.14-5.708-3.433-7.994C218.709,275.217,216.036,274.074,212.994,274.074z"			/>		<path d="M302.935,68.951c-7.806-14.378-17.891-26.506-30.266-36.406c-12.367-9.896-26.271-17.799-41.685-23.697			C215.567,2.952,200.246,0,185.016,0C127.157,0,83,25.315,52.544,75.946c-1.521,2.473-2.046,5.137-1.571,7.993			c0.478,2.852,1.953,5.232,4.427,7.135l46.824,35.691c2.474,1.52,4.854,2.281,7.139,2.281c3.427,0,6.375-1.525,8.852-4.57			c13.702-17.128,23.887-28.072,30.548-32.833c8.186-5.518,18.461-8.276,30.833-8.276c11.61,0,21.838,3.046,30.692,9.132			c8.85,6.092,13.271,13.135,13.271,21.129c0,8.942-2.375,16.178-7.135,21.698c-4.757,5.518-12.754,10.845-23.986,15.986			c-14.842,6.661-28.457,16.988-40.823,30.978c-12.375,13.991-18.558,28.885-18.558,44.682v12.847c0,3.62,0.994,7.187,2.996,10.708			c2,3.524,4.425,5.283,7.282,5.283h68.521c3.046,0,5.708-1.472,7.994-4.432c2.279-2.942,3.426-6.036,3.426-9.267			c0-4.757,2.617-11.14,7.847-19.13c5.235-7.994,11.752-14.186,19.562-18.565c7.419-4.186,13.219-7.56,17.411-10.133			c4.196-2.566,9.664-6.715,16.423-12.421c6.756-5.712,11.991-11.375,15.698-16.988c3.713-5.614,7.046-12.896,9.996-21.844			c2.956-8.945,4.428-18.558,4.428-28.835C314.639,98.397,310.734,83.314,302.935,68.951z"/>	</g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>';
    const delayEventFactory = new DelayEventFactory();
    const captainsDocumentFactory = new CaptainsDocumentFactory();
    const eventTypeInputGroupFactory = new EventTypeInputGroupFactory();
    const eventTypeInputDelayEventTypeMapFactory = new EventTypeInputDelayEventTypeMapFactory();
    const eventTypeInputExcludeTimeEventTypeMapFactory = new EventTypeInputExcludeTimeEventTypeMapFactory();
    const { newEventTypeInput, createNewEventTypeInputArray } = EventTypeInputFactory();

    const newEventType = (eventType: EventTypeBM, levelId: RotationTreeEnum, grMand: boolean): EventType | null => {
        let evType: EventType | null = null;
        if (eventType) {
            evType = newEventTypeItem(eventType, levelId, grMand);
        }
        return evType;
    };

    const newEventTypeItem = (item: EventTypeBM, levelId: RotationTreeEnum, grMand: boolean): EventType => {
        const eventTypeInputArray: EventTypeInput[] = [];
        item.eventTypeInputList.map((etig) => {
            eventTypeInputArray.push(newEventTypeInput(etig));
        });
        const eventTypeInputArraySorted = eventTypeInputArray.sort((eti) => eti.inputOrder);
        return new EventType(
            item.eventTypeId,
            item.eventTypeGroupId,
            item.name,
            item.shortName,
            item.mandatory,
            item.showInPlanView,
            item.allowedInPlan,
            grMand && item.mandatory,
            item.ordered,
            item.portLog,
            item.statementOfFacts,
            item.documentTemplateUrl,
            item.icon,
            item.nextEventTypeInGroupId,
            eventTypeInputArraySorted,
            item.shoresideInstruction,
            item.selectable,
            item.editable,
            item.deletable,
            item.eventTypeGroupRequiredArray,
            item.delayEvent ? delayEventFactory.newDelayEvent(item.delayEvent) : null,
            item.captainsDocument ? captainsDocumentFactory.newCaptainsDocument(item.captainsDocument) : null,
            item.concurrentEventTypeInputId,
            levelId,
            null,
            eventTypeInputGroupFactory.newEventTypeInputGroup(item.eventTypeInputGroupList),
            null,
            null,
            item.deleted,
            null,
            [],
            [],
            item.useInSimpleMode,
            item.onlyUseInSimpleMode
        );
    };

    const createNewEventType = (eventType: EventType): EventType | null => {
        if (eventType) {
            const newEvType = new EventType(
                eventType.eventTypeId,
                eventType.eventTypeGroupId,
                eventType.name,
                eventType.shortName,
                eventType.mandatory,
                eventType.showInPlanView,
                eventType.allowedInPlan,
                eventType.actualMandatory,
                eventType.ordered,
                eventType.portLog,
                eventType.statementOfFacts,
                eventType.documentTemplateUrl,
                eventType.icon,
                eventType.nextEventTypeInGroupId,
                createNewEventTypeInputArray(eventType.eventTypeInputArray),
                eventType.shoresideInstruction,
                eventType.selectable,
                eventType.editable,
                eventType.deletable,
                eventType.eventTypeGroupRequiredArray,
                delayEventFactory.createDelayEvent(eventType.delayEvent),
                captainsDocumentFactory.createCaptainsDocument(eventType.captainsDocument),
                eventType.concurrentEventTypeInputId,
                eventType.levelId,
                eventType.parentSequenceNumber,
                eventType.eventTypeInputGroupArray,
                eventType.eventTypeGroupSequenceIdentity,
                eventType.eventTypeGroupSequenceDependencyIdentity,
                eventType.deleted,
                eventType.dependencyDisplayName,
                eventTypeInputDelayEventTypeMapFactory.newEventTypeInputDelayEventTypeMapList(eventType.eventTypeInputDelayEventTypeMapArray),
                eventTypeInputExcludeTimeEventTypeMapFactory.newEventTypeInputExcludeTimeEventTypeMapList(
                    eventType.eventTypeInputExcludeTimeEventTypeMapArray
                ),
                eventType.useInSimpleMode,
                eventType.onlyUseInSimpleMode
            );
            newEvType.eventTypeGroup = eventType.eventTypeGroup;
            return newEvType;
        }
        return null;
    };

    const createNewEventTypeForToolbox = (eventType: EventType, parentSeqNr: number | null): EventType | null => {
        if (eventType) {
            const newEvType = new EventType(
                eventType.eventTypeId,
                eventType.eventTypeGroupId,
                eventType.name,
                eventType.shortName,
                eventType.mandatory,
                eventType.showInPlanView,
                eventType.allowedInPlan,
                eventType.actualMandatory,
                eventType.ordered,
                eventType.portLog,
                eventType.statementOfFacts,
                eventType.documentTemplateUrl,
                eventType.icon,
                eventType.nextEventTypeInGroupId,
                createNewEventTypeInputArray(eventType.eventTypeInputArray),
                eventType.shoresideInstruction,
                eventType.selectable,
                eventType.editable,
                eventType.deletable,
                eventType.eventTypeGroupRequiredArray,
                delayEventFactory.createDelayEvent(eventType.delayEvent),
                captainsDocumentFactory.createCaptainsDocument(eventType.captainsDocument),
                eventType.concurrentEventTypeInputId,
                eventType.levelId,
                parentSeqNr,
                eventType.eventTypeInputGroupArray,
                eventType.eventTypeGroupSequenceIdentity,
                eventType.eventTypeGroupSequenceDependencyIdentity,
                eventType.deleted,
                eventType.dependencyDisplayName,
                eventTypeInputDelayEventTypeMapFactory.newEventTypeInputDelayEventTypeMapList(eventType.eventTypeInputDelayEventTypeMapArray),
                eventTypeInputExcludeTimeEventTypeMapFactory.newEventTypeInputExcludeTimeEventTypeMapList(
                    eventType.eventTypeInputExcludeTimeEventTypeMapArray
                ),
                eventType.useInSimpleMode,
                eventType.onlyUseInSimpleMode
            );
            newEvType.eventTypeGroup = eventType.eventTypeGroup;
            return newEvType;
        }
        return null;
    };

    const createUnknownEvent = (event: TankersEvent, eventTypeGroup: EventTypeGroup) => {
        const unknownEvent = new EventType(
            -1,
            -1,
            'Unknown event. Event type id: ' + event.eventTypeId,
            '',
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            null,
            questionMark,
            null,
            null,
            'This event is unknown. Possible explanation is that Odfjell have removed event from configuration. Please contact support for more information. ',
            false,
            false,
            false,
            null,
            null,
            null,
            null,
            event.getEventLevel(),
            null,
            null,
            null,
            null,
            false,
            null,
            [],
            [],
            null,
            null
        );
        unknownEvent.eventTypeGroup = eventTypeGroup;
        return unknownEvent;
    };

    return {
        newEventType,
        newEventTypeItem,
        createNewEventType,
        createNewEventTypeForToolbox,
        createUnknownEvent,
    };
};
